<template>
  <div class="location">
    <div class="location-name">{{location.name}}</div>
    <a class="vector-icon map-link" @click="viewOnMap" v-if="location.coordinatesAvailable">{{labels.viewOnMap}}</a>
    <div class="company-name" v-if="location.companyName">{{location.companyName}}</div>
    <div class="address" v-if="location.address1">{{location.address1}}</div>
    <div class="address" v-if="location.address2">{{location.address2}}</div>
    <div class="address"><span>{{location.postalCode}}&nbsp;</span><span>{{location.postalLocation || location.city}}</span><span v-if="location.state">, {{location.state}}</span>&nbsp;</div>
    <div class="address">{{location.country}}</div>
    <div class="phone" v-if="location.phone" v-html="location.phone"></div>
    <a class="blue-arrow animated get-in-contact" v-if="location.contactable" @click="viewContactBox">{{labels.getInContact}}</a>
    <Modal :visible="showMap" @close="showMap = false" :title="location.name" v-if="showMap">
      <Map :pins="[location]"></Map>
    </Modal>
    <Modal :visible="showContactBox" @close="showContactBox = false" :title="labels.getInContact" v-if="showContactBox">
      <ContactForm v-if="!isSubmitting && !submitted && !gotError" @submit-form="submitForm" :country="location.country"></ContactForm>
      <div v-if="isSubmitting" class="billboard">
        {{labels.get("Submitting. Please wait...") }}
      </div>
      <div v-if="submitted" class="billboard">
        {{labels.get("Contact request submitted successfully") }}
      </div>
      <div v-if="gotError" class="billboard error">
        <span>{{labels.get("There was an issue submitting your request. Please try again later.") }}</span>
        <span>{{ errorMessage }}</span>
      </div>
    </Modal>
  </div>
</template>

<script>
import {Labels, Utils, DataLayer} from "../services.js";
import Modal from "./Modal.vue";
import Map from "./Map.vue";
import ContactForm from "./ContactForm.vue"

export default {
  name: 'Location',
  props: ["location"],
  components: {
    Modal, Map, ContactForm
  },
  data () {
    return {
      labels: Labels,
      showMap: false,
      showContactBox: false,
      isSubmitting: false,
      submitted: false,
      gotError: false,
      errorMessage: ""
    }
  },
  methods: {
    viewOnMap() {
      this.showMap = true;
    },
    viewContactBox() {
      this.showContactBox = true;
      this.isSubmitting = false;
      this.submitted = false;
      this.gotError = false;
    },
    async submitForm(data) {
      const loader = Utils.showLoader(".modal-body", true);
      this.isSubmitting = true;
      try {
        let postData = this.constructPostData(data);
        await DataLayer.submitForm(postData);
        this.isSubmitting = false;
        this.submitted = true;
      }
      catch (err)
      {
        Utils.showStatusMessage(
            `Could not submit form. Error: ${err.message}.`,
            "red"
          );
          this.errorMessage = err.message;
          this.gotError = true;
          this.isSubmitting = false;
          this.submitted = false;
      }
      finally {
        Utils.removeLoader(loader);
      }
    },
    constructPostData(payload) {
      if (!payload) return null;
      let campaignData = (cla && cla.component && cla.component.analytics) ? cla.component.analytics.getCampaignData() : undefined;
      
      return {
        allowDataProcessing: payload.ack1 ? "On" : "Off",
        campaignContent: campaignData ? campaignData.content : "",
        campaignMedium: campaignData ? campaignData.medium : "",
        campaignName: campaignData ? campaignData.name : "",
        campaignTerm: campaignData ? campaignData.term : "",
        campaignSource: campaignData ? campaignData.source : "",
        company: payload.company || "",
        context: window.location.href,
        currentItemID: this.getHiddenFieldValue("#hidCurrentPageId"),
        email: payload.email,
        firstName: payload.firstName,
        isCampaignLandingPage: campaignData ? campaignData.isLandingPage : false,
        lastName: payload.lastName,
        locationCountry: this.location.country,
        locationId: this.location.id,
        locationName: this.location.name,
        message: payload.message,
        newsletter: payload.ack2 ? "On" : "Off",
        phone: payload.phone || "",
        title: payload.title,
        userCountryId: payload.countryId,
        userCountryName: payload.countryName
      };
    },
    getHiddenFieldValue(sel) {
      let fld = document.querySelector(sel);
      if (fld) return fld.value;
      else return "";
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.location {
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
}
.location-name {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 10px;
}
.map-link {
  margin-bottom: 10px;
}

.company-name {
  font-weight: 300;
}

.address {

}

.get-in-contact{
  align-self: flex-start;
  cursor: pointer;
  font-weight: 500;
}

.billboard {
  width: 800px;
  max-width: 100%;
  height: 500px;
  max-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.billboard.error {
  color: red;
  display: flex;
  flex-direction: column;
  text-align: center;
}

</style>
